import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const LocationAssignment = ({ formData, onFormChange, errors, locations }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
          <Icon name="MapPin" size={20} color="var(--color-success)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Location Assignment</h2>
          <p className="text-sm text-muted-foreground">Specify where the work will be performed</p>
        </div>
      </div>
      <div className="space-y-4">
        <Select
          label="Primary Location"
          options={locations}
          value={formData?.primaryLocation}
          onChange={(value) => onFormChange('primaryLocation', value)}
          error={errors?.primaryLocation}
          required
          searchable
          placeholder="Select work location"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Building/Area <span className="text-error">*</span>
            </label>
            <input
              type="text"
              value={formData?.buildingArea}
              onChange={(e) => onFormChange('buildingArea', e?.target?.value)}
              placeholder="e.g., Building A, Zone 3"
              className={`w-full px-4 py-3 rounded-lg border ${
                errors?.buildingArea ? 'border-error' : 'border-border'
              } bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors`}
            />
            {errors?.buildingArea && (
              <p className="mt-1 text-sm text-error">{errors?.buildingArea}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Specific Location/Equipment ID
            </label>
            <input
              type="text"
              value={formData?.specificLocation}
              onChange={(e) => onFormChange('specificLocation', e?.target?.value)}
              placeholder="e.g., Panel-E-204"
              className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors"
            />
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4 border border-border">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={18} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
            <div className="text-sm text-muted-foreground">
              <p className="font-medium text-foreground mb-1">Location-Specific Requirements</p>
              <p>Based on your selected location, additional safety protocols may be automatically applied to this permit.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationAssignment;